<template>
	<div class="result-horizontal row mt-2"
	     :class="'result-horizontal-type-' + type + ' result-horizontal-index-' + index + ' result-horizontal-' + identifier + ' result-horizontal-' + labels.length">
		<div class="col-4 identifier">
			<div class="identifier-inner pr-4">{{ identifier }}</div>
		</div>
		<div class="col-8">
			<div
					class="row result-bar-container"
					v-for="(percentage, i) in percentages"
					:class="['result-bar-container-' + i, hasValues && i === largestIndex ? 'result-bar-container-largest' : null]"
			>
				<div class="container-fluid pl-3">
					<div class="row">
						<div class="col-9">
							<div class="result-bar label" :style="{ width: percentage + '%' }">
								<span v-if="showBarLabels">{{ labels[i] }}</span>
							</div>
						</div>
						<div class="col-3 percentage">
							<span class="percentage-inner">
								{{ getPercentageText(percentage) }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'result-horizontal',
		props: {
			index: {
				type: Number,
				required: true
			},
			identifier: {
				type: String,
			},
			percentages: {
				type: Array
			},
			labels: {
				type: Array
			},
			largestIndex: {
				type: Number,
				required: false,
				default: false,
			},
			showBarLabels: {
				type: Boolean,
				default: false,
			}
		},
		methods: {
			getPercentageText(percentage) {
				return Math.round(percentage) + '%';
			}
		},
		computed: {
			hasValues() {
				for (let percentage of this.percentages) {
					if (percentage > 0) {
						return true;
					}
				}

				return false;
			},
			areaName() {
				switch (this.identifier) {
					case 'jylland':
						return 'Jylland';
					case 'funen':
						return 'Fyn';
					case 'sealand':
						return 'Sjælland';
					case 'bornholm':
						return 'Bornholm';
					default:
						return this.identifier;
				}
			},
			type() {
				return this.percentages.length >= 2 ? 'multiple' : 'single';
			},
		},
		data() {
			return {
				areaPictureScale: .8,
			}
		}
	}
</script>

<style lang="scss" scoped>
	$barHeight: 180px;

	.percentage-inner {
		@include alignCenterY();
	}

	.result-area {
		position: relative;

		.picture {
			text-align: center;
			height: 600px;

			.no-drag-image {
				width: 100%;
				height: 100%;

				img {
					max-height: 100%;
				}
			}
		}

		&.result-area-funen {
			.picture {
				padding-top: 80%;
			}
		}

		&.result-area-sealand {
			.picture {
				padding-top: 55%;
			}
		}

		&.result-area-bornholm {
			.picture {
				padding-top: 90%;
			}
		}

		.text-container {
			position: absolute;

			top: 40%;
			font-size: 40pt;
			font-weight: bold;
			text-align: center;
			width: 100%;
			padding: 0 80px;
		}

		.bottom-bar-title {
			width: 100%;
			font-weight: bold;
			font-size: 20pt;
			text-align: center;
		}

		.bottom-bar {
			position: relative;
			top: -50px;
		}

		.result-bars {
			background: #333333;
			height: 50px;
			margin: 0 80px;
			overflow: hidden;
			white-space: nowrap;

			.result-bar {
				height: 100%;
				color: white;
				font-weight: bold;
				font-size: 25pt;
				padding: 0 10px;

				&.result-bar-0 {
					background: $bar1color1;
					text-align: left;
				}

				&.result-bar-1 {
					background: $bar2color1;
					text-align: right;
				}

				&.result-bar-2 {
					background: $bar3color1;
				}
			}
		}
	}

	.result-bar-container {
		.result-bar {
			font-size: 22pt;
			white-space: nowrap;
			min-width: 5px;
			height: $barHeight / 2;
			line-height: $barHeight / 2;
			padding: 0 10px;
		}
	}

	.result-horizontal {
		margin-bottom: 20px;
	}

	.identifier {
		font-size: 45pt;
		font-weight: bold;
		position: relative;

		.identifier-inner {
			text-align: right;
			@include alignCenterY();
			right: 0;
			line-height: 120%;
		}
	}

	.label {
		font-weight: bold;
		font-size: 30pt !important;
	}

	.percentage {
		font-weight: bold;
		font-size: 30pt;
	}

	.result-horizontal-1 {
		.percentage {
			line-height: $barHeight;
			font-size: 45pt;
		}

		.result-bar-container {
			.result-bar {
				height: $barHeight;
				line-height: $barHeight;
			}
		}
	}

	.result-horizontal {
		margin-bottom: 50px;

		&.result-horizontal-index-0 {
			.result-bar-container-0 .result-bar {
				background: $bar1color1;
			}

			.result-bar-container-1 .result-bar {
				background: $bar1color2;
			}
		}

		&.result-horizontal-index-1 {
			.result-bar-container-0 .result-bar {
				background: $bar2color1;
			}

			.result-bar-container-1 .result-bar {
				background: $bar2color2;
			}

		}

		&.result-horizontal-index-2 {
			.result-bar-container-0 .result-bar {
				background: $bar3color1;
			}

			.result-bar-container-1 .result-bar {
				background: $bar3color2;
			}

		}
	}
</style>
